import { normalizeProductStatus, Product, productApi, } from '../services/home/productApi';
import { useAppSelector } from '../store/hooks';
import { selectSelectedAccountId } from '../store/selectors/userSelectors';
export const useContabilidadeDigitalData = ({ enabled = true, debounceMs = 300, } = {}) => {
    const selectedAccountId = useAppSelector(selectSelectedAccountId);
    const { data, isLoading, error, refetch } = productApi.useGetProductQuery({
        product: Product.CONTABILIDADE_DIGITAL,
        selectedCompanyPartyId: selectedAccountId || '',
        debounceMs,
    }, {
        skip: !enabled || !selectedAccountId,
        refetchOnMountOrArgChange: true,
        refetchOnFocus: false,
        refetchOnReconnect: true,
    });
    return {
        refetch: refetch,
        status: normalizeProductStatus(data?.result?.status),
        connectedAccountsCount: data?.result?.metadata?.connectedAccounts ?? 0,
        isLoading,
        error: error,
    };
};
